export function buildLogicalNameToFieldKeyMap(fields = []) {
  const invertedMap = {};

  if(!Array.isArray(fields)) return invertedMap

  if (Array.isArray(fields)) {
    fields.forEach((field) => {
      const fieldKey = field?.fieldKey;
      const mapFieldKey = field?.mapFieldKey;
      if (fieldKey && mapFieldKey) {
        invertedMap[mapFieldKey] = fieldKey;
      }
    });
  }

  return invertedMap;
}

export function getTemplateFieldValue(templateFields, fieldKey, logicalNameMap) {
  if (!templateFields || !fieldKey) return undefined;

  const logicalName = Object.keys(logicalNameMap).find(
    key => logicalNameMap[key] === fieldKey
  );

  if (logicalName && Object.prototype.hasOwnProperty.call(templateFields, logicalName)) {
    return templateFields[logicalName];
  }

  if (Object.prototype.hasOwnProperty.call(templateFields, fieldKey)) {
    return templateFields[fieldKey];
  }

  return undefined;
}
